import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClientWH } from '@shared/services/ApiClient';
import { createHttpClient } from '@adapters/HttpClient';
import { useMemo } from 'react';
import { CartApiAdapter } from '../adapters/CartApiAdapter';
import { CartService } from '../services/CartService';

export const useDeleteCart = () => {
  const queryClient = useQueryClient();

  // 🎯 Memoizar instancias del servicio para evitar recrearlas en cada render
  const cartService = useMemo(() => {
    const httpClient = createHttpClient(apiClientWH);
    const apiAdapter = new CartApiAdapter(httpClient);
    return new CartService(apiAdapter);
  }, []);

  return useMutation({
    mutationFn: (id: number) => cartService.deleteCart(id),
    onSuccess: () => {
      // Invalidar la caché de carritos para refrescar la lista
      queryClient.invalidateQueries({ queryKey: ['carts'] });
    },
  });
};
